<div class="w-[100%] p-[40px] pb-[30px] pt-[0px]">
  <div class="flex">
    <div
      class="flex flex-col justify-start gap-[27px] items-start mt-[17px] w-[25%]"
    >
      <div class="flex flex-col items-start">
        <p class="attribute-header">Project Type</p>
        <p class="attribute-value">{{pqqData?.projectDetails?.project_type?.name || "Not Selected"}}</p>
      </div>
  
      <div class="flex flex-col items-start">
        <p class="attribute-header">Grade</p>
        <p class="attribute-value">{{pqqData?.projectDetails?.grade?.name || "Not Selected"}}</p>
      </div>
  
      <div class="flex flex-col items-start">
        <p class="attribute-header">Start Date</p>
        <p class="attribute-value">{{pqqData?.projectDetails?.start_date ? (pqqData?.projectDetails?.start_date | date : "yyyy-MM-dd") : "Not Selected"}}</p>
      </div>
  
      <div class="flex flex-col items-start">
        <p class="attribute-header">End Date</p>
        <p class="attribute-value">{{pqqData?.projectDetails?.end_date ? (pqqData?.projectDetails?.end_date | date : "yyyy-MM-dd") : "Not Selected"}}</p>
      </div>
  
      <div class="flex flex-col items-start">
        <p class="attribute-header">Country</p>
        <p class="attribute-value">{{pqqData?.projectDetails?.country?.name || "Not Selected"}}</p>
      </div>
  
      <div class="flex flex-col items-start">
        <p class="attribute-header">city</p>
        <p class="attribute-value">{{pqqData?.projectDetails?.city || "Not Selected"}}</p>
      </div>
  
      <div class="flex flex-col items-start">
        <p class="attribute-header">Zip Code</p>
        <p class="attribute-value">{{pqqData?.projectDetails?.zip || "Not Selected"}}</p>
      </div>
  
      <div class="flex flex-col items-start">
        <p class="attribute-header">Street</p>
        <p class="attribute-value">{{pqqData?.projectDetails?.street|| "Not Selected"}}</p>
      </div>
    </div>
    <div class="w-[75%]">
      <p class="intro flex justify-start !mt-[20px] !mb-0">Brief</p>
      <p class="breif-value" [innerHTML]="
      getSanitizedHtml(pqqData?.projectDetails?.description)
      ">
      </p>
  
      <div class="flex justify-between w-[100%]">
        <div class="w-[50%]">
          <p class="intro flex justify-start !mt-[29px] !mb-0">
            Site Conditions
          </p>
          <p class="breif-value" [innerHTML]="
          getSanitizedHtml(pqqData?.projectDetails?.site_conditions)
          ">
          </p>
          <p class="intro flex justify-start !mt-[10px] !mb-0">
            Key Deliverables
          </p>
  
          <ul class="!pl-0 mt-[8px]">
            <div class="flex" *ngFor="let goals of pqqData?.projectDetails?.goals">
              <div class="flex">
                <span>{{goals?.name}}</span>
              </div>
            </div>
          </ul>
        </div>
        <div class="ml-[10px] w-[50%] pt-[39px]">
          <div class="flex-1 flex items-center">
            <iframe
              width="100%"
              height="244px"
              style="border: 0"
              loading="lazy"
              [src]="mapLink"
            >
            </iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>